import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { SortButtonSortingDirection } from './sort-button-constants.js';

function sortArray(values, sorting) {
  var sortedValues = _toConsumableArray(values); // sort ascending by default


  sortedValues.sort(function (objA, objB) {
    var propA = objA[sorting.field];
    var propB = objB[sorting.field];
    if (typeof propA === "number" && typeof propB === "number") return propA - propB;
    if (typeof propA === "string" && typeof propB === "string") return propA.localeCompare(propB);

    if (typeof propA === "boolean" && typeof propB === "boolean") {
      if (propA === propB) {
        return 0;
      }

      return propA ? -1 : 1;
    }

    if (propA instanceof Date && propB instanceof Date) {
      if (propA < propB) {
        return -1;
      }

      if (propA > propB) {
        return 1;
      }
    }

    return 0;
  });

  if (sorting.direction === SortButtonSortingDirection.DESC) {
    return sortedValues.reverse();
  }

  return sortedValues;
}

export { sortArray };
//# sourceMappingURL=sort-button-utils.js.map
